import axios from 'axios';
import SwalService from './swalService'

const axiosInstance = axios.create({
    baseURL: 'https://backend.eamconsulting.com.pe',
    timeout: 600000, // 10 minutos
});

// Interceptor para agregar el token en los encabezados de las solicitudes
axiosInstance.interceptors.request.use(
    (config) => {
        if (!config.url.startsWith('/auth')) {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = token.startsWith('Bearer ')
                    ? token
                    : `Bearer ${token}`;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor para manejar la expiración del token
axiosInstance.interceptors.response.use(
    (response) => {
        // Devolver la respuesta si es exitosa
        return response;
    },
    (error) => {
        // Si el servidor responde con 401 (Unauthorized), redirigir al inicio de sesión
        if (error.response && error.response.status === 401) {
            // Eliminar el token del almacenamiento local
            localStorage.removeItem('token');
            SwalService.close();
            // Redirigir al inicio de sesión
            window.location.href = '/login'; // Asegúrate de que esta ruta coincida con la de tu aplicación
        }

        // Rechazar el error para que pueda manejarse en las vistas si es necesario
        return Promise.reject(error);
    }
);

export default {
    // Servicio para peticiones GET
    get(url, params = {}) {
        return axiosInstance.get(url, { params });
    },

    // Servicio para peticiones POST
    post(url, data = {}) {
        return axiosInstance.post(url, data);
    },

    // Servicio para descargar un archivo
    async downloadFile(url, fileName = 'archivo_descargado') {
        try {
            const response = await axiosInstance.get(url, {
                responseType: 'blob', // Necesario para manejar archivos binarios
            });

            // Crear un archivo desde el blob
            const blob = new Blob([response.data]);
            const downloadUrl = window.URL.createObjectURL(blob);

            // Si el servidor no envía `Content-Disposition`, usar el nombre proporcionado
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = decodeURIComponent(fileNameMatch[1]);
                }
            }

            // Crear un enlace temporal para la descarga
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // Limpieza
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
            throw error;
        }
    },

    // Servicio para descargar múltiples archivos
    async downloadFiles(url, ids, fileName = 'archivo_descargado') {
        try {
            const response = await axiosInstance.post(url, ids, {
                responseType: 'blob', // Necesario para manejar archivos binarios
            });

            // Crear un archivo desde el blob
            const blob = new Blob([response.data]);
            const downloadUrl = window.URL.createObjectURL(blob);

            // Si el servidor no envía `Content-Disposition`, usar el nombre proporcionado
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = decodeURIComponent(fileNameMatch[1]);
                }
            }

            // Crear un enlace temporal para la descarga
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // Limpieza
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
            throw error;
        }
    },
};
